import {createSelector} from 'helpers';
import {day} from './day';
import {activities} from 'store';

export const allDay = createSelector(
  day,
  day => day.filter(activity => activities.allDay(activity)),
);

export const anyTime = createSelector(
  day,
  day => day.filter(activity => !activity.time && !activities.allDay(activity)),
);
